'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var isPremiumOrVIP = function isPremiumOrVIP(entitlements) {
  if (entitlements && entitlements.length) {
    return entitlements.includes('sl_premium') || entitlements.includes('sl_vip') || entitlements.includes('sl_vip_advertiser');
  }
  return false;
};

exports.default = isPremiumOrVIP;


//////////////////
// WEBPACK FOOTER
// ./~/@surfline/quiver-react/dist/helpers/isPremiumOrVip.js
// module id = 360
// module chunks = 0